import BackgroundDynamic from '@activebrands/core-web/components/BackgroundDynamic';
import Link from '@activebrands/core-web/components/Link';
import { ImageBackground, VideoBackground } from '@activebrands/core-web/libs/storyblok/storyblok';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import { getInsetFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';
import Paragraph from 'components/text/Paragraph';

const textBreakStyles = { minWidth: 0, overflowWrap: 'break-word' };

const StyledLink = styled(Link, { display: 'block', ...getInsetFocusRingStyles() });

const Wrapper = styled('div', {
    position: 'relative',
    overflow: 'hidden',
});

const Overlay = styled('div', {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    width: '100%',
    aspectRatio: 'var(--ratio-vertical-secondary)',
    background: 'var(--color-bg-hover-highlight-card)',
    zIndex: 'var(--zindex-background)',
    transition: 'var(--transition-medium)',

    ':hover': {
        opacity: '40%',
    },
});

const Label = styled('div', {
    ...textBreakStyles,
    zIndex: 'calc(var(--zindex-middleground) + 1)',
    color: 'var(--color-text-highlight-card)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    marginTop: '10px',
});

interface HighlightCardProps {
    background: ImageBackground | VideoBackground | undefined;
    label: string;
    link: string;
}

const HighlightCard = ({ background, label, link }: HighlightCardProps) => {
    const [css] = useStyletron();
    return (
        //  @todo: js-file
        //  eslint-disable-next-line
        //  @ts-ignore
        <StyledLink to={link}>
            <Wrapper>
                <Overlay />
                <div
                    className={css({
                        aspectRatio: 'var(--ratio-vertical-secondary)',
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '8px',
                    })}
                >
                    <BackgroundDynamic $style={{ zIndex: 0 }} background={background} loading="eager" />
                </div>
                <Label>
                    <Paragraph fontKeys="Primary/24_94_-1_700">{label}</Paragraph>
                </Label>
            </Wrapper>
        </StyledLink>
    );
};

export default HighlightCard;
